{
  "columns": {
    "launchedAt": "Date",
    "name": "Nom",
    "rowsCount": "Nombre de lignes",
    "status": "Statut"
  },
  "export": {
    "generate": "Générer un export",
    "load": "Charger les configurations d'export",
    "notifications": {
      "generate": {
        "success": "Extraction demandée avec succès"
      },
      "load": {
        "success": "Configurations d'export synchronisées avec succès"
      }
    },
    "placeholder": "Sélectionnez un export"
  },
  "import": {
    "bulkUpdate": {
      "summaryModal": {
        "confirmButton": {
          "label_one": "Lancer et mettre à jour {{ count }} produit",
          "label_many": "Lancer et mettre à jour {{ count }} produits",
          "label_other": "Lancer et mettre à jour {{ count }} produits"
        },
        "erroredRows_one": "{{ count }} ligne en erreur",
        "erroredRows_many": "{{ count }} lignes en erreur",
        "erroredRows_other": "{{ count }} lignes en erreur",
        "errorMessage": "Une erreur est survenue lors de la mise à jour en masse des produits",
        "errorTitle": "Erreur",
        "successMessage": "Les produits ont été mis à jour en masse avec succès",
        "successTitle": "Succès",
        "title": "Récapitulatif de la mise à jour en masse des produits",
        "totalRows_one": "{{ count }} ligne totale",
        "totalRows_many": "{{ count }} lignes totales",
        "totalRows_other": "{{ count }} lignes totales",
        "validRows_one": "{{ count }} ligne valide",
        "validRows_many": "{{ count }} lignes valides",
        "validRows_other": "{{ count }} lignes valides",
        "warnedRows_one": "{{ count }} ligne avec avertissement",
        "warnedRows_many": "{{ count }} lignes avec avertissement",
        "warnedRows_other": "{{ count }} lignes avec avertissement",
        "warningsTitle": "Avertissements trouvés"
      },
      "templateCard": {
        "description": "Mise à jour en masse de plusieurs produits en une seule fois en téléchargeant un fichier CSV. Fonctionnalité réservée aux administrateurs. Pour plus d'informations, consultez la <a>documentation</a>.",
        "title": "Mise à jour en masse des produits",
        "uploadButton": {
          "label": "Importer un fichier",
          "tooltip": "Taille maximale: {{ maxSize }} Mo"
        }
      }
    },
    "businessPartner": {
      "templateCard": {
        "description": "Alimenter et consolider votre répertoire de partenaires commerciaux, qu'ils soient fournisseurs, agents, négociants.",
        "title": "Partenaires Commerciaux",
        "uploadButton": {
          "label": "Importer un fichier",
          "tooltip": "Maximum size: {{ maxSize }} MB"
        }
      }
    },
    "legacy": {
      "templateCard": {
        "description": "Partager toutes les informations produits, opérations et fournisseurs dans un fichier .csv unique. Ce fichier sera traité ultérieurement par l'équipe support.",
        "downloadButton": {
          "label": "Modèle",
          "tooltip": "Télécharger un modèle de fichier à compléter."
        },
        "title": "Ingestion générique",
        "uploadButton": {
          "label": "Import fichier",
          "tooltip": "Taille maximale: {{ maxSize }} Mo"
        }
      }
    },
    "list": {
      "filters": {
        "error": "Erreur",
        "failed": "Echec",
        "pending": "En cours",
        "search": "Rechercher",
        "success": "Succès",
        "title": "Filtres"
      },
      "table": {
        "columns": {
          "date": {
            "header": "Date",
            "tooltip": "Date et heure de l'import."
          },
          "file": {
            "header": "Fichier",
            "tooltip": "Nom du fichier."
          },
          "rows": {
            "header": "Lignes",
            "tooltip": "Nombre de lignes contenues dans le fichier"
          },
          "status": {
            "cell": {
              "error": "Erreur",
              "failed": "Echec",
              "pending": "En cours",
              "success": "Succès"
            },
            "header": "Statut",
            "tooltip": "En cours, Echec, Erreur, Terminé"
          },
          "type": {
            "header": "Type",
            "tooltip": "Type de données importée."
          },
          "user": {
            "header": "Utilisateur",
            "tooltip": "Compte utilisateur responsable de l'import."
          }
        }
      }
    }
  },
  "page": {
    "title": "Data Transfer"
  },
  "tabs": {
    "export": "Export",
    "import": "Import"
  },
  "templateDocumentation": "Documentation",
  "upload": {
    "erase": "Vos données ont été effacées, veuillez télécharger un nouveau fichier",
    "error": "Une erreur est survenue lors du téléchargement de vos données",
    "info": "Trace For Good s'engage à vérifier le bon format des données renseignées dans ce fichier, toutefois, il est important de noter que nous ne pouvons pas garantir l'exactitude ou la validité du contenu des données. Par conséquent, il incombe à l'utilisateur de s'assurer que les données renseignées sont précises, complètes et cohérentes.",
    "success": "Vos données ont été téléchargées ! La traçabilité commence maintenant"
  }
}
